const emailRegEx = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Email Regex
const numberRegEx = /^[0-9]*$/; // Number Regex 
const websiteURLRegEx = /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{1,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/; // Web Site URL Regex
const passwordRegEx = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,15})"); // Regex Expression for Password
const domainRegex = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/; // Reggex for Domain Check
const alphanumericRegex = /^[a-zA-Z0-9]*$/; // Alpha Numeric RegEx
const phoneRegex = /^[0-9\s-]{8,15}$/; // Phone Number RegEx validation on submit
const nameRegEx =  /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/;
const phoneOnChangeRegex = /^[0-9\s-]+$/; // Phone Number RegEx validation on Change
const alphanumericRegexWithHyphen = /^[a-zA-Z0-9-]{0,50}$/; // Alpha Numeric RegEx with hyphen

const alphanumericRegexPO = /^[a-zA-Z0-9-]{0,50}$/; // RegEx for PO Number
const emailRegExSendActivation = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;  
const websiteURLReg = /^https:\/\/(?:www\.)?[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/;   // website regex expression 
const alphanumericRegexConnectwise = /^[a-zA-Z0-9_!@#$%^&*()-+=]+$/; // Alpha Numeric RegEx
const alphanumericRegexPKey = /^[a-zA-Z0-9]+$/;
const cardExpDateRegEx = /^[0-9\/]*$/;
const tenantIdRegex = /^[a-zA-Z0-9\-]{36}$/;                                // Tenant ID Validation 36 Letters and atleast one hyphen
const mcaAgreementDetnameRegEx = /^[a-zA-Z\s]*$/;
const organisationSizeRegEx = /^(?=.*[1-9])\d{1,25}$/;
const addressRegex = /^[a-zA-Z0-9\- ,]{1,100}$/;
const mpnIdRegex = /^[0-9]+$/;
const durationRegex = /^[1-9][0-9]*$/;
const AddemailLocallyRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;


export { emailRegEx, numberRegEx, websiteURLRegEx, passwordRegEx, domainRegex, alphanumericRegex, alphanumericRegexWithHyphen, phoneRegex, nameRegEx, phoneOnChangeRegex, alphanumericRegexPO, emailRegExSendActivation, websiteURLReg, alphanumericRegexConnectwise, alphanumericRegexPKey,
  cardExpDateRegEx, tenantIdRegex,  mcaAgreementDetnameRegEx, organisationSizeRegEx, addressRegex, mpnIdRegex, durationRegex, AddemailLocallyRegex
 }